module.exports = new __parcel__URL__("apply_c_zh-cn.6db3b1c3.webp").toString();